var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"st borderb-gray pt20 mb15"},[_c('router-link',{staticClass:"more fr trans3 fs14 tc6 mt5",attrs:{"to":_vm.more}},[_vm._v("更多>>")]),_c('span',{staticClass:"fs24 lh10 prelative st-nm before dinline-block"},[_vm._v(_vm._s(_vm.stitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }